export default {
    'todoList': '我的待办',
    'toggleBatch': '批量处理',
    'batchApprove': '批量同意',
    'toggleStandalone': '切换单一处理模式',
    'toreadList': '我的待阅',
    'doneList': '我的已办',
    'readList': '我的已阅',
    'batchWaiting': '任务加载中,请稍后...',
    'approveSuggestion': '审批意见',
    'batchOk': '我知道了',
    'onlySupportMobileWrite': "手写签名,仅支持移动端填写",
    'batchHandle': '批量处理',
    'myFlow': '我的流程',
    'delegationFlow': '流程委托',
    'searchFlow': '流程查询',
    'instanceSearch': '流程实例查询',
    'taskSearch': '任务查询',
    'startFlow': '发起流程',
    'batchHandleFlow': '批量处理',
    'searchFlowPlaceholder': '搜索流程名称、发起人',
    'orderNuber': '序号',
    'flowName': '流程名称',
    'workflowName': '模板名称',
    'curActivity': '当前节点',
    'stayTime': '停留时间',
    'originatorName': '发起人',
    'departmentName': '发起人组织',
    'timeout': '已超时',
    'noDataText': '你已超高效的完成任务啦，休息一下吧~',
    'searchNoDataText': '暂无搜索结果',
    'loadFailedText': '内容加载失败',
    'refresh': '刷新',
    'circulated': '已阅',
    'flowType': '流程类型',
    'sourceName': '传阅来源',
    'reciveTime': '接收时间',
    'flowTemplate': '流程模板',
    'startTime': '开始时间',
    'endTime': '结束时间',
    'processing': '进行中',
    'completed': '已完成',
    'canceled': '已作废',
    'draft': '草稿',
    'exception': '流程异常',
    'flowStatus': '流程状态',
    'more': '更多',
    'add': '新增',
    'delete': '删除',
    'collapse': '收起',
    'reset': '重置',
    'search': '查询',
    'ok': '确定',
    'cancel': '取消',
    'deleteTrustTips1': '确定要删除这条委托吗？',
    'deleteTrustTips2': '删除后委托失效，被委托人将不再审批/发起流程。',
    'deleteFailed': '删除失败，请重新尝试',
    'deleteSuccess': '删除成功',
    'timeRange': '{start} 至 {end}',
    'plzSelect': '请选择',
    'resolveTime': '处理时间',
    'approvalNode': '审批节点',
    'resolveRzt': '处理结果',
    'noContent': '暂无内容',
    'initiationTime': '发起时间',
    'cancelTime': '作废时间',
    'resolver': '处理人',
    'curResolver': '当前处理人',
    'usedTime': '已用时',
    'originatorDepartment': '发起人所属部门',
    'finishedTime': '完成时间',
    'costTime': '耗时',
    'state': '流程状态',
    'all': '全部',
    'noStarted': '未打开',
    'resolving': '处理中',
    'beCancled': '被取消',
    'searchFlowName': '搜索流程名称',
    'searchRzt': '搜索结果',
    'items': '条',
    'reason': '原因',
    'showAll': '已展示全部搜索结果',
    'commonFlow': '常用流程',
    'setSevenFlows': '可设置7个流程',
    'flowItems': '个',
    'setCommon': '设为常用',
    'cancelCommon': '取消常用',
    'sevenFlowsIsMost': '最多设置7个常用流程',
    'timeOutAfter': '后超时',
    'beUrged': '被催办',
    'total': '共{num}条',
    'sequenceNo': '单据号',
    'inputSequenceNo': '请输入单据号',
    'approval': {
        'agree': '同意',
        'reject': '驳回',
        'forward': '转办',
        'canceled': '被取消',
        'undo': '未处理'
    },
    'workflowState': {
        'draft': '草稿',
        'processing': '进行中',
        'completed': '已完成',
        'canceled': '被取消',
        'exception': '异常',
    },
    'showAllTodo': '已展示全部待办内容，请尽快处理吧~',
    'showAllToRead': '已展示全部待阅内容，请尽快处理吧~',
    'showAllResult': '已展示全部内容',
    'showAllSearch': '已展示全部搜索内容，请尽快处理吧~',
    'item': '项',
    'delegation': {
        'client': '委托人',
        'consignor': '被委托人',
        'delegateType': '委托类型',
        'entrustedPeriod': '受托期限',
        'operation': '操作',
        'workflowApproval': '流程审批',
        'startWorkflow': '流程发起',
        'workflowScope': '流程范围',
        'wholeProcess': '全部流程',
        'partProcess': '部分流程',
        'addDelegation': '新建委托',
        'editDelegation': '编辑委托',
        'createDelegationTips1': '请先完善当前委托信息',
        'createDelegationTips2': '修改委托成功！',
        'createDelegationTips3': '流程委托时间重叠',
        'createDelegationTips4': '创建委托成功！',
    }
};
